import {Ten99} from 'Agent/1099s/models/1099';
import {AsyncPage, Empty} from 'Core/models/Async';
import {DateRange, EmptyDateRange} from 'Core/models/DateRange';
import {FilterOptionUnion, FilterOptionValue} from 'Core/models/FilterOption';
import {Page} from 'Core/models/Page';
import {createAction} from 'Shared/utilities/actionCreator';
import {ValidAgentNumber} from 'Users/models/AgentNumber';

export enum Ten99ActionType {
  GET_TEN99s = 'ten99/GET_TEN99s',
  CHANGE_TEN99s = 'ten99/CHANGE_TEN99s',
  CHANGE_TEN99_FILTERS = 'ten99/CHANGE_TEN99_FILTERS',
}


export type FilterEnum = {
  name: string;
  value: string;
};

export const EmptyTen99Filter: Ten99Filters = {
  accountName: '',
  accountNumber: '',
  history: '',
  sourceId: FilterOptionValue.EmptyOption(),
  statementDate: EmptyDateRange,
  taxYear: '',
  taxFormType: FilterOptionValue.EmptyOption()
};

export type Ten99Filters = {
  accountNumber: string;
  accountName: string;
  history: string;
  taxYear: string;
  taxFormType: FilterOptionUnion;
  statementDate: DateRange;
  sourceId: FilterOptionUnion;
};

export const changeTen99Filters = (filters: Ten99Filters) =>
  createAction(Ten99ActionType.CHANGE_TEN99_FILTERS, {filters});

export const clear1099s = () => createAction(Ten99ActionType.CHANGE_TEN99s, DEFAULT_STATE.ten99s);

export const getTen99s = (
  agentNumbers: ValidAgentNumber[],
  encryptedIdentifier: string,
  isNewYork: boolean,
  page?: Page<Ten99>,
  filter?: Ten99Filters
) =>
  createAction(Ten99ActionType.GET_TEN99s, {
    agentNumbers,
    isNewYork,
    encryptedIdentifier,
    page,
    filter,
  });

export const changeTen99s = (ten99s: AsyncPage<Page<Ten99>>) => createAction(Ten99ActionType.CHANGE_TEN99s, ten99s);

type Ten99State = {
  ten99s: AsyncPage<Page<Ten99>>;
  ten99sFilter: Ten99Filters;
};

export const DEFAULT_STATE: Ten99State = {
  ten99s: new Empty(),
  ten99sFilter: EmptyTen99Filter,
};

type Ten99Action =
  | ReturnType<typeof changeTen99Filters>
  | ReturnType<typeof getTen99s>
  | ReturnType<typeof changeTen99s>;

export default (state: Ten99State = DEFAULT_STATE, action: Ten99Action): Ten99State => {
  switch (action.type) {
    case Ten99ActionType.CHANGE_TEN99_FILTERS:
      return {
        ...state,
        ten99sFilter: action.payload.filters,
      };
    case Ten99ActionType.CHANGE_TEN99s:
      return {
        ...state,
        ten99s: action.payload,
      };
    default:
      return state;
  }
};
